'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stackNormalized;

var _stack = require('./stack');

var _stack2 = _interopRequireDefault(_stack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stackNormalized(props) {
    return (0, _stack2.default)(props, {
        normalize: true
    });
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/rumble-charts/lib/helpers/transforms/stackNormalized.js
 ** module id = 1574
 ** module chunks = 3
 **/